import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import { Spin } from "antd";
import {
  Col,
  Form,
  Row,
  Modal,
  Button,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { get, post, postFormData } from "../../../helpers/api_helper";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomInput from "../../../CustomControls/CustomInput";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import { SVGICON } from "../../../constant/theme";
import moment from "moment";
import {
  GET_GetLogoTypeDropDownList,
  POST_GetLogoValidityDetailByID,
  POST_LogoValidityInsert,
  POST_LogoValidityUpdate,
} from "../../../helpers/url_helper";

const AddLogoValidity = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const [logoTypeOptions, setLogoTypeOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    LogoType: Yup.string().trim().required("Logo Type is required field"),
    ValidFrom: Yup.string().trim().required("Valid From is required field"),
    ValidTo: Yup.string().trim().required("Valid To is required field"),

    NABLLabCertificateNo: Yup.string().when(
      "LogoType",
      ([LogoType], schema) => {
        if (LogoType == 1)
          return Yup.string().required(
            "NABL Lab Certificate No is required field",
          );
        return schema;
      },
    ),

    NABLLogoWidth: Yup.string().when("LogoType", ([LogoType], schema) => {
      if (LogoType == 1)
        return Yup.string().required(
          "Letter Head NABL Logo Width is required field",
        );
      return schema;
    }),

    NABLLogoHeight: Yup.string().when("LogoType", ([LogoType], schema) => {
      if (LogoType == 1)
        return Yup.string().required(
          "Letter Head NABL Logo Height is required field",
        );
      return schema;
    }),

    // NABLLabCertificateNo: Yup.string()
    //   .trim()
    //   .required("NABL Lab Certificate No is required field"),

    // NABLLogoWidth: Yup.string()
    //   .trim()
    //   .required("Letter Head NABL Logo Width is required field"),
    // NABLLogoHeight: Yup.string()
    //   .trim()
    //   .required("Letter Head NABL Logo Height is required field"),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      LogoValidityIDEncrypted: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      LogoType: "",
      ValidFrom: new Date(),
      ValidTo: new Date(),
      NABLLabCertificateNo: "",
      NABLLogoFilePath: "",
      NABLLogoFileKey: "",
      NABLLogoFileUrl: "",
      NABLLogoWidth: "",
      NABLLogoHeight: "",
      IsEditable: true,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      LogoType,
      ValidFrom,
      ValidTo,
      NABLLogoFilePath,
      NABLLogoFileKey,
      NABLLogoFileUrl,
      NABLLogoHeight,
      NABLLogoWidth,
      IsEditable,
    },
  } = formik;

  useEffect(() => {
    if (!ValidFrom) {
      formik.setFieldValue("ValidFrom", "");
    }
    if (!ValidTo) {
      formik.setFieldValue("ValidTo", "");
    }

    if (ValidTo && ValidTo < ValidFrom) {
      formik.setFieldValue("ValidTo", ValidFrom);
    }
  }, [ValidFrom, ValidTo]);

  const handleValidSubmit = (values) => {
    if (LogoType == 1) {
      if (NABLLogoFilePath == "") {
        if (NABLLogoFileUrl == "") {
          formik.setFieldError(
            "NABLLogoFilePath",
            "NABL Logo File is required field",
          );
          formik.setFieldTouched("NABLLogoFilePath", true);
          return false;
        }
      }
    }

    setIsLoading(true);

    // let payload = {
    //   ...values,
    //   ValidFrom: values?.ValidFrom
    //     ? moment(values?.ValidFrom).format("YYYY-MM-DD").replace(/^\-/, "")
    //     : "",
    //   ValidTo: values?.ValidTo
    //     ? moment(values?.ValidTo).format("YYYY-MM-DD").replace(/^\-/, "")
    //     : "",
    //   CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    //   CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
    // };

    let formData = new FormData();
    formData.append("BranchIDEncrypt", AuthUser?.BranchIDEncrypt);
    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("CreatedByEncrypted", AuthUser?.ReferenceIDEncrypt);
    formData.append("LogoValidityIDEncrypted", values?.LogoValidityIDEncrypted);

    formData.append("LogoType", values?.LogoType);
    formData.append(
      "ValidFrom",
      values?.ValidFrom
        ? moment(values?.ValidFrom).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    );
    formData.append(
      "ValidTo",
      values?.ValidTo
        ? moment(values?.ValidTo).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    );

    formData.append(
      "NABLLabCertificateNo",
      LogoType == 1 ? values?.NABLLabCertificateNo : "",
    );
    formData.append(
      "NABLLogoFilePath",
      LogoType == 1 ? values?.NABLLogoFilePath : "",
    );
    formData.append(
      "NABLLogoFileUrl",
      LogoType == 1 ? values?.NABLLogoFileUrl : "",
    );
    formData.append(
      "NABLLogoWidth",
      LogoType == 1 ? values?.NABLLogoWidth : "",
    );
    formData.append(
      "NABLLogoHeight",
      LogoType == 1 ? values?.NABLLogoHeight : "",
    );

    postFormData(
      PrimaryIdParam ? POST_LogoValidityUpdate : POST_LogoValidityInsert,
      formData,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getLogoTypeDDL = async () => {
    setIsLoading(true);
    await get(GET_GetLogoTypeDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setLogoTypeOptions(
            response?.List?.map((item) => ({
              label: item?.LogoTypeName,
              value: item?.LogoType,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getLogoTypeDDL();
    if (PrimaryIdParam) {
      getLogoValidityDetailByID(window.atob(PrimaryIdParam));
    }
  }, []);

  const getLogoValidityDetailByID = async (logoValidityID) => {
    setIsLoading(true);
    await post(POST_GetLogoValidityDetailByID, {
      LogoValidityIDEncrypted: logoValidityID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            ValidFrom: response?.ValidFrom ? new Date(response?.ValidFrom) : "",
            ValidTo: response?.ValidTo ? new Date(response?.ValidTo) : "",
            NABLLabCertificateNo: response?.NABLLabCertificateNo,
            NABLLogoFileUrl: response?.NABLLogoFilePath,
            NABLLogoFilePath: "",
            NABLLogoWidth: response?.NABLLogoWidth,
            NABLLogoHeight: response?.NABLLogoHeight,
            IsEditable: response?.IsEditable,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const [imageTitle, setImageTitle] = useState("");
  const [imageSrc, setImageSrc] = useState("");
  const [imageWidth, setImageWidth] = useState("");

  const uploadNABLLogoFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.png|.gif|.jpeg|.jpg)$/;

      if (!file.type.match(pattern)) {
        warningMessage("Select valid file!");
        formik.setFieldValue("NABLLogoFilePath", "");
        formik.setFieldValue(
          "NABLLogoFileKey",
          Math.random().toString(9).substring(2, 9),
        );
      } else {
        formik.setFieldValue("NABLLogoFilePath", file);
      }
    } else {
      formik.setFieldValue("NABLLogoFilePath", "");
      formik.setFieldValue(
        "NABLLogoFileKey",
        Math.random().toString(9).substring(2, 9),
      );
    }
  };

  const viewNABLLogo = (e) => {
    setImageSrc(
      NABLLogoFilePath
        ? URL.createObjectURL(NABLLogoFilePath)
        : NABLLogoFileUrl,
    );
    setImageWidth(NABLLogoWidth ? NABLLogoWidth + "mm" : "32mm");
    setImageTitle("Letter Head NABL Logo Image");
    setShowImageModal(true);
  };

  const deleteNABLLogo = (e) => {
    formik.setFieldValue("NABLLogoFilePath", "");
    formik.setFieldValue(
      "NABLLogoFileKey",
      Math.random().toString(9).substring(2, 9),
    );
    formik.setFieldValue("NABLLogoFileUrl", "");
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} NABL Accreditation Validity
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Logo Type"
                      name="LogoType"
                      placeholder={"Select Logo Type"}
                      component={CustomSelect}
                      options={logoTypeOptions}
                      required
                      autoFocus
                      isDisabled={
                        LogoType == 1 && IsEditable == false ? true : false
                      }
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Valid From"
                      name="ValidFrom"
                      placeholder={"Select Valid From"}
                      component={CustomFlatpickr}
                      required
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                      }}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Valid To"
                      name="ValidTo"
                      placeholder={"Select Valid To"}
                      component={CustomFlatpickr}
                      required
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                        minDate: ValidFrom ? new Date(ValidFrom) : "",
                      }}
                    />
                  </Col>
                  {LogoType == 1 ? (
                    <>
                      <Col lg={3}>
                        <Field
                          label="NABL Lab Certificate No"
                          name="NABLLabCertificateNo"
                          placeholder={"Enter NABL Lab Certificate No"}
                          component={CustomInput}
                          maxLength={20}
                        />
                      </Col>

                      <Col lg={3}>
                        {(NABLLogoFileUrl || NABLLogoFilePath) && (
                          <>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="Delete"
                              style={{ float: "right" }}
                              onClick={deleteNABLLogo}
                            >
                              {SVGICON.DeleteDanger}
                            </Link>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="View"
                              style={{ float: "right" }}
                              onClick={viewNABLLogo}
                            >
                              <i className="fa fa-image"></i>
                            </Link>
                          </>
                        )}
                        <div className="mb-2">
                          <label>
                            NABL Logo{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Upload the NABL logo to be included on
                                    official documents. This logo represents
                                    accreditation and compliance with NABL
                                    standards.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="NABLLogoFilePath"
                            accept="image/png, image/gif, image/jpeg"
                            key={NABLLogoFileKey || ""}
                            onChange={(e) => {
                              uploadNABLLogoFile(e);
                            }}
                          />
                          <ErrorMessage
                            name="NABLLogoFilePath"
                            component="div"
                            className="invalid-feedback animated fadeInUp"
                            style={{ display: "block" }}
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <label>
                          Letter Head NABL Logo Width x Height{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  Specify the dimensions (width x height) of the
                                  NABL logo to be included on the letterhead.
                                  Ensure that these measurements are accurate
                                  for proper placement and scaling.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <div className="d-flex">
                          <Field
                            type="number"
                            name="NABLLogoWidth"
                            placeholder={"Width (mm)"}
                            component={CustomInput}
                            onChange={(e) => {
                              if (e?.target?.value < 211) {
                                formik.setFieldValue(
                                  "NABLLogoWidth",
                                  e?.target?.value,
                                );
                              }
                            }}
                          />
                          <div className="mt-2 ms-1 me-1">x</div>
                          <Field
                            type="number"
                            name="NABLLogoHeight"
                            placeholder={"Height (mm)"}
                            component={CustomInput}
                            onChange={(e) => {
                              if (e?.target?.value < 100) {
                                formik.setFieldValue(
                                  "NABLLogoHeight",
                                  e?.target?.value,
                                );
                              }
                            }}
                          />
                        </div>
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showImageModal}
          onHide={setShowImageModal}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>{imageTitle}</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowImageModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body className="ps-1 pt-0">
            <img src={imageSrc} style={{ maxWidth: imageWidth }} />
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default AddLogoValidity;
